import { UserServiceResponseInterface } from '../../../actions/userService/userServiceTypes'

export interface UserServiceReducerInterface {
  BTID: UserServiceResponseInterface['externalIdV2'] | null
  data: UserServiceResponseInterface | null
  status: {
    errorResponse: {
      code?: number,
      message?: string
    },
    hasData: boolean,
    hasError: boolean,
    isFetching: boolean
    isSubmitting?: boolean
    isLoggedin?: boolean
  }
}

const defaultState: UserServiceReducerInterface = {
  BTID: null,
  data: null,
  status: {
    errorResponse: {
      message: 'Invalid email or password, please try again.'
    },
    hasData: false,
    hasError: false,
    isFetching: false
  }
}

export default defaultState
